export const reducerCases = {
    SET_TOKEN : "SET_TOKEN",
    SET_PLAYLIST : "SET_PLAYLIST",
    SET_USER: "SET_USER",
}